<template>
	<div id="app">
		<div class="preloader text-center" v-show="loading">
			<div class="loading"></div>
		</div>

		<router-view to="/" class="view"></router-view>
		<Login v-if="login" />
		<Sidemenu :sidemenu="sidemenu" :user="user" v-if="user"></Sidemenu>
		<Largeimg :imgs="showlargeimg.imgs" :index="showlargeimg.index" v-if="showlargeimg.show"></Largeimg>
		<Message v-if="message.isshow" :message="message.info"></Message>
		<Firstlogin v-if="firstlogin"></Firstlogin>
		<Userleveldialog v-if="userleveldialog"></Userleveldialog>

		<div v-if="isMobile && !islogin && tologinbtn" style="position: fixed;bottom: 0;left: 0;width: -webkit-fill-available;;padding: 0.7rem 1rem;background-color: rgba(0, 0, 0, 0.8);border-radius: 0.5rem;display: flex;justify-content: space-between;
				align-items: center;z-index: 999;margin:1rem">
			<div style="color: #fff;font-size: 0.8rem;font-weight: 500;">
				<div>Login to GCI,</div>
				<div>Travel around the world</div>
			</div>
			<div style="display: flex;align-items: center;">
				<div style="background-color: #02e9be;border-radius: 5rem;color: #000;font-size: 1rem;font-weight: 500;display: flex;align-items: center;justify-content: center;padding: 0.3rem 1rem;
						cursor: pointer;" @click="tomlogin">
					Log in
				</div>
				<div style="opacity: 0.5;margin-left: 0.5rem;" @click="tologinbtn = false">
					<img src="../src/assets/imgs/icon-close.png"
						style="min-width: 2rem;min-height: 2rem;max-width: 2rem;max-height: 2rem;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import axios from 'axios'
// import {baseUrl} from './assets/js/public.js'
import Login from './components/login.vue'
import Sidemenu from './components/sidemenu.vue'
import Largeimg from './components/largeimg.vue'
import Message from './components/message.vue'
import {
	WOW
} from 'wowjs'
import Firstlogin from './components/firstlogin.vue'
import Userleveldialog from './components/userleveldialog.vue'
export default {
	name: 'app',
	components: {
		Login,
		Sidemenu,
		Largeimg,
		Message,
		Firstlogin,
		Userleveldialog
	},
	data() {
		return {
			login: false,
			islogin: false,
			isMobile: false,
			loading: false,
			sidemenu: false,
			user: null,
			showlargeimg: {
				show: false,
				imgs: [],
				index: 0
			},
			noloading: false,
			message: {
				isshow: false,
				info: null
			},
			firstlogin: false,
			// gotop: false,
			tologinbtn: true,
			userleveldialog: false
		}
	},
	methods: {
		_isMobile() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			localStorage.setItem('isMobile', flag)
			this.isMobile = flag
			// console.log(2333, this.isMobile)
			// return flag;
		},
		getuser() {
			this.request({
				method: 'get',
				url: '/gci/user/info',
			}).then(res => {
				this.user = res.data
				// console.info('user',this.user)
				if (!this.user.countryId) {
					this.firstlogin = true
				}
			}).catch(error => {
				console.error(error.response)
			})
		},
		tomlogin() {
			this.$router.push({
				name: 'mlogin',
				query: {
					type: 0
				}
			})
		}
		// toTop() {
		//   let top = document.documentElement.scrollTop || document.body.scrollTop;
		//   // 实现滚动效果 
		//   const timeTop = setInterval(() => {
		// 	document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
		// 	if (top <= 0) {
		// 		this.totop = false
		// 	  clearInterval(timeTop);
		// 	}
		//   }, 10);
		// },
	},
	created() {
		// this._isMobile()
	},
	mounted() {
		// alert(123)
		this._isMobile()
		this.$bus.$on("loading", value => {
			this.loading = value
		});
		this.$bus.$on("tologinbtn", value => {
			this.tologinbtn = value
		});
		this.$bus.$on("login", value => {
			this.login = value
		});
		this.$bus.$on("sidemenu", value => {
			this.sidemenu = value
		});
		this.$bus.$on("largeimg", value => {
			this.showlargeimg = value
		});
		this.$bus.$on('message', value => {
			this.message.isshow = true
			this.message.info = value
			setTimeout(() => {
				this.message.isshow = false
			}, 3000);
		})
		this.$bus.$on("firstlogin", value => {
			this.firstlogin = value
		});
		this.$bus.$on("userleveldialog", value => {
			this.userleveldialog = value
		});
		// this.$bus.$on("noloading",value=>{
		//     this.noloading = value
		// });
		// this.$bus.$on("totop",value=>{
		//     this.totop = value
		// 	this.toTop()
		// });
		// window.addEventListener("scroll", this.handleScroll, true);
		if (localStorage.getItem('token')) {
			this.islogin = true
			this.getuser()
		}
		new WOW().init();
	}
}
</script>

<style>
#app {
	width: 100vw;
	overflow: hidden
}

/* #app::-webkit-scrollbar{display: none;} */

/*按钮悬浮*/
.el-button:hover {
	color: black !important;
}

.el-scrollbar {
	.el-scrollbar__bar {
		opacity: 1 !important;
	}
}

/*按钮点击*/
.el-button:focus {
	color: white !important;
}

.loading {
	margin: 40px auto;
	position: relative;
	width: 15rem;
	height: 15rem;
	background-image: url(assets/imgs/loading.gif);
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat
}

/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
@import url("assets/css/style.css");
@import url("assets/css/widgets.css");
@import url("assets/css/responsive.css");
@import url("assets/css/public.css");
@import url("assets/css/index.css");
</style>